import { Box, styled } from '@mui/material'
import { MAX_COLUMN_WIDTH } from 'ComponentLibrary/src/templates/PageTemplate/constants'

type FloatingSaveContainerProps = {
    sidebarWidth: number
}

export const FloatingSaveContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'sidebarWidth',
})<FloatingSaveContainerProps>(({ theme, sidebarWidth }) => ({
    bottom: '32px',
    position: 'absolute',
    gap: '24px',
    display: 'flex',
    zIndex: 1001,

    [theme.breakpoints.down('lg')]: {
        left: 'unset',
        right: '32px',
    },

    [theme.breakpoints.up('lg')]: {
        left: `${sidebarWidth + 2 * MAX_COLUMN_WIDTH}px`,
    },
}))

export default FloatingSaveContainer
